import { t } from '@lingui/core/macro';
import { FieldValues, Path } from 'react-hook-form';

import { FieldController, FieldControllerProps } from '../FieldController';
import { FieldSwitch, FieldSwitchProps } from './FieldSwitch';

interface ControllerProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends Path<TFieldValues> = Path<TFieldValues>,
> extends Omit<FieldControllerProps<FieldSwitchProps, TFieldValues, TName>, 'Field'> {
    /** The switch must be on. */
    required?: boolean;
}

export function FieldSwitchControlled<
    TFieldValues extends FieldValues = FieldValues,
    TName extends Path<TFieldValues> = Path<TFieldValues>,
>({ required, validate, ...props }: ControllerProps<TFieldValues, TName>): JSX.Element {
    return <FieldController Field={FieldSwitch} validate={createValidator({ required, validate })} {...props} />;
}

function createValidator({
    required,
    validate,
}: {
    required?: boolean;
    validate?: (x: unknown) => string | undefined;
}) {
    return (x: unknown): string | undefined => {
        if (required && x === false) {
            return t`Required`;
        }
        if (validate) {
            return validate(x);
        }
        return undefined;
    };
}
